import Vue from 'vue'
import msal from 'vue-msal'
import axios from 'axios'
import VueAxios from 'vue-axios'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import VueScrollTo from 'vue-scrollto';

import './assets/css/main.css';

import router from './router'
import App from './App.vue'
import store from './store/index'
import { readConfig, config } from './config/config'
import { readFeatureToggle, featureToggle, msgFeatureToggle } from './config/featureToggle'

import SemSideBar from './layouts/SemSideBar.vue'
import ComSideBar from './layouts/ComSideBar.vue'


import CustomModal from './components/modal/plugin.js'
Vue.use(CustomModal);

import NotifyPlugin from './components/notify/plugin.js'
Vue.use(NotifyPlugin);

import VueAnalytics from 'vue-analytics';

import './components/GlobalComponents'

//FIX: Bug MSAL - Limpa os cookies para solução de contorno do Bug da atualização do token
var cookies = document.cookie.split(";");
for (var i = 0; i < cookies.length; i++) {
  var cookie = cookies[i];
  var eqPos = cookie.indexOf("=");
  var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
}

readFeatureToggle.then(r => {
  if (r) {
    Vue.prototype.$featureToggle = featureToggle.dados;
    Vue.prototype.$msgFeatureToggle = msgFeatureToggle;


    readConfig.then(r => {
      if (r) {

        Vue.prototype.$Configs = config;

        Vue.use(msal, {
          auth: {
            clientId: config.AzureAd.ClientId,
            tenantId: config.AzureAd.TenantId,
            redirectUri: config.AzureAd.RedirectUri,
            requireAuthOnInitialize: true
          },
          request: {
            scopes: ['user.read']
          },
          cache: {
            cacheLocation: 'sessionStorage'
          },
          framework: {
            globalMixin: true
          },
          graph: {
            callAfterInit: true,
            baseUrl: 'https://graph.microsoft.com/beta',
            endpoints: {
              // ...
              // 'key' : endpoint
              // ...
              profile: '/me',
              photo: { url: '/me/photo/$value', responseType: 'blob', force: true }
            }
          }
        });

        Vue.use(VueAxios, axios)

        
        Vue.use(VueMaterial)
        Vue.material.locale.dateFormat = 'dd/MM/yyyy';
        Vue.material.locale.days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
        Vue.material.locale.shortDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
        Vue.material.locale.shorterDays = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
        Vue.material.locale.months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
        Vue.material.locale.shortMonths = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        Vue.material.locale.shorterMonths = ['J', 'F', 'M', 'A', 'M', 'Ju', 'Ju', 'A', 'Se', 'O', 'N', 'D'];
        Vue.material.locale.cancel = 'Cancelar';

        Vue.use(VueScrollTo, {
          container: "html",
          duration: 200,
          easing: "ease",
          offset: -30,
          force: false,
          cancelable: false,
          onStart: false,
          onDone: false,
          onCancel: false,
          x: false,
          y: true
        })

        //Layouts
        Vue.component('sem-sidebar-layout', SemSideBar);
        Vue.component('com-sidebar-layout', ComSideBar);

        Vue.config.productionTip = false

        // Configuration VueAnalytics
        if (document.location.hostname != 'localhost' && !document.location.hostname.includes("krthomolog.com.br")) {
          Vue.use(VueAnalytics, {
            id: 'UA-122331996-14',
            router
          });
        }

        //INICIA INSTÂNCIA VUE
        new Vue({
          router,
          store,
          render: h => h(App),
          created() {
            if (!this.$msal.isAuthenticated()) {
              //alert('Não Autenticado!!! (main.js)');
              //this.$msal.signIn();
            }
          }
        }).$mount('#app')
      }
    })
  }
})